import reducer from './reducer'

import * as facilityAmendmentsOperations from './operations'
import * as facilityAmendmentsSelectors from './selectors'

export { facilityAmendmentsOperations, facilityAmendmentsSelectors }

export default reducer
